/**
 * 检查元素是否在视口内
 * @param element
 * @returns {boolean}
 */
export default (element, { ratio = 0.5 } = {}) => {
  const { top, bottom } = element.getBoundingClientRect();
  const clientHeight = window.innerHeight || document.documentElement.clientHeight;
  const isInView =
    (top <= 0 && bottom <= clientHeight && bottom / clientHeight > ratio) ||
    (top <= 0 && bottom > clientHeight) ||
    (top >= 0 && bottom <= clientHeight) ||
    (top >= 0 && bottom > clientHeight && (clientHeight - top) / clientHeight > ratio);
  return isInView;
};
